export const getIndustriesUrl = () => '/industries';

export const getSubIndustriesUrl = (id: string | number) => `/industries/${id}/sub_industries`;
